import { defineMessages } from 'react-intl';

/** The copy of the People list of a campaign (design outreach-v2 g1, g2, g3). */
export const peopleMessages = defineMessages({
  title: { id: 'app.outreach.people.titleV4', defaultMessage: 'People' },
  intro: {
    id: 'app.outreach.people.introV4',
    defaultMessage: 'Everyone Plug picked for this song. Open a person to read the pitch and see what happened.',
  },
  filterAll: { id: 'app.outreach.people.filter.all', defaultMessage: 'All' },
  filterPlanned: { id: 'app.outreach.people.filter.planned', defaultMessage: 'Planned' },
  filterOpened: { id: 'app.outreach.people.filter.opened', defaultMessage: 'Opened' },
  filterListened: { id: 'app.outreach.people.filter.listened', defaultMessage: 'Listened' },
  filterReplied: { id: 'app.outreach.people.filter.replied', defaultMessage: 'Replied' },
  filterAdded: { id: 'app.outreach.people.filter.added', defaultMessage: 'Added' },
  allKinds: { id: 'app.outreach.people.filter.allKinds', defaultMessage: 'All kinds' },
  kindFilter: { id: 'app.outreach.people.filter.kind', defaultMessage: 'Kind' },
  resultFilter: { id: 'app.outreach.people.filter.result', defaultMessage: 'Result' },
  colWho: { id: 'app.outreach.people.col.who', defaultMessage: 'Who' },
  colWhy: { id: 'app.outreach.people.col.why', defaultMessage: 'Why Plug picked them' },
  colStatus: { id: 'app.outreach.people.col.status', defaultMessage: 'Status' },
  dayToday: { id: 'app.outreach.people.day.today', defaultMessage: 'Today' },
  dayYesterday: { id: 'app.outreach.people.day.yesterday', defaultMessage: 'Yesterday' },
  dayRelease: { id: 'app.outreach.people.day.release', defaultMessage: '{day} · release day' },
  dayPlanned: { id: 'app.outreach.people.day.planned', defaultMessage: 'Planned · {day}' },
  dayCounts: { id: 'app.outreach.people.day.counts', defaultMessage: '{sent} sent · {waiting} waiting' },
  daySent: { id: 'app.outreach.people.day.sent', defaultMessage: '{sent} sent' },
  dayWaiting: { id: 'app.outreach.people.day.waiting', defaultMessage: '{waiting} waiting' },
  showMore: { id: 'app.outreach.people.showMore', defaultMessage: 'Show more from earlier days' },
  empty: {
    id: 'app.outreach.people.emptyPicked',
    defaultMessage: 'Nobody yet. The people show here as soon as Plug picks them.',
  },
  emptyFiltered: { id: 'app.outreach.people.emptyFiltered', defaultMessage: 'Nobody matches these filters.' },

  // a row
  ownContact: { id: 'app.outreach.people.row.ownContact', defaultMessage: 'Your own contact' },
  followers: {
    id: 'app.outreach.people.row.followers',
    defaultMessage: '{count, plural, one {# follower} other {# followers}}',
  },
  resultAdded: { id: 'app.outreach.people.result.added', defaultMessage: 'Added the song' },
  resultReplied: { id: 'app.outreach.people.result.replied', defaultMessage: 'Replied' },
  resultListened: { id: 'app.outreach.people.result.listened', defaultMessage: 'Listened 30 s+' },
  resultOpened: { id: 'app.outreach.people.result.opened', defaultMessage: 'Opened the song' },
  resultSent: { id: 'app.outreach.people.result.sent', defaultMessage: 'Sent {time}' },
  resultScheduled: { id: 'app.outreach.people.result.scheduled', defaultMessage: 'Scheduled' },
  resultFollowUp: { id: 'app.outreach.people.result.followUp', defaultMessage: 'Follow-up on {date}' },
  resultFollowUpPlain: { id: 'app.outreach.people.result.followUpPlain', defaultMessage: 'Follow-up waits' },
  openDetails: { id: 'app.outreach.people.row.openDetails', defaultMessage: 'Open the details of {name}' },
  blockMenu: { id: 'app.outreach.people.row.blockMenu', defaultMessage: 'Block or change {name}' },

  // the block menu (g2)
  blockPerson: { id: 'app.outreach.people.block.person', defaultMessage: 'Never pitch this person again' },
  blockPersonSub: { id: 'app.outreach.people.block.personSub', defaultMessage: 'For every song of this artist' },
  blockTarget: { id: 'app.outreach.people.block.target', defaultMessage: 'Never pitch {name}' },
  blockTargetSub: {
    id: 'app.outreach.people.block.targetSub',
    defaultMessage: 'The other playlists and outlets of this person stay in',
  },
  fewer: { id: 'app.outreach.people.block.fewer', defaultMessage: 'Fewer like this' },
  fewerSub: { id: 'app.outreach.people.block.fewerSub', defaultMessage: 'Plug moves similar ones down the list' },
  stopFollowUp: { id: 'app.outreach.people.block.stopFollowUp', defaultMessage: 'Stop the follow-up' },
  stopFollowUpSub: {
    id: 'app.outreach.people.block.stopFollowUpSub',
    defaultMessage: 'The pitch already went out',
  },
  blocked: { id: 'app.outreach.people.toast.blocked', defaultMessage: 'Plug never pitches {name} again.' },
  blockedCancelled: {
    id: 'app.outreach.people.toast.blockedCancelled',
    defaultMessage:
      'Plug never pitches {name} again. {count, plural, one {# waiting pitch} other {# waiting pitches}} stopped.',
  },
  undo: { id: 'app.outreach.people.toast.undo', defaultMessage: 'Undo' },
  fewerDone: { id: 'app.outreach.people.toast.fewer', defaultMessage: 'Plug moves people like {name} down the list.' },
  followUpStopped: {
    id: 'app.outreach.people.toast.followUpStopped',
    defaultMessage: 'The follow-up does not go out.',
  },
  actionFailed: { id: 'app.outreach.people.toast.failed', defaultMessage: 'That did not work. Try again.' },

  // the drawer (g3)
  drawerTitle: { id: 'app.outreach.people.drawer.title', defaultMessage: 'The pitch to {name}' },
  cancelFollowUp: { id: 'app.outreach.people.drawer.cancelFollowUp', defaultMessage: 'Cancel the follow-up' },
  neverPitchAgain: { id: 'app.outreach.people.drawer.neverPitchAgain', defaultMessage: 'Never pitch again' },
  openInContacts: { id: 'app.outreach.people.drawer.openInContacts', defaultMessage: 'Open in Contacts' },
});
